<script>
import find from 'lodash/find';
import {mapGetters} from 'vuex';
import DatePicker from '@/components/DatePicker';

export default {
  components: {DatePicker},

  props: {
    orderDetails: {
      type: Object,
      default: () => {},
    },
    partType: {
      type: String,
      default: '',
    },
    isDist: Boolean,
  },

  computed: {
    deliveryMethodName() {
      let selectedMethod = find(
        this.orderDetails.shippingMethods,
        (method) => method.code === this.orderDetails.selectedShipping
      );
      return selectedMethod ? selectedMethod.name : '';
    },

    defaultPickerDate() {
      let defaultDate = new Date();

      if (this.orderDetails && this.orderDetails.shipmentInfo && this.orderDetails.shipmentInfo.deliveryDate) {
        defaultDate = new Date(this.orderDetails.shipmentInfo.deliveryDate);
      }

      // Ensures the defaultDate is always higher than the minDate (new Date()) so the default
      // value actually populates in flatpickr
      defaultDate.setSeconds(59);
      defaultDate.setMinutes(59);

      return defaultDate;
    },

    // The logic is very similar to defaultPickerDate
    distDeliveryDate() {
      let distDefaultDate = this.defaultPickerDate;
      distDefaultDate.setHours(23); // for potential edge cases

      return distDefaultDate;
    },
    ...mapGetters('backend', ['consumerFriendlyMode']),
  },

  watch: {
    orderDetails: {
      deep: true,
      handler() {
        if (this.$refs.dateRangePicker) {
          if (this.isDist) {
            this.$refs.dateRangePicker.fp.setDate(this.distDeliveryDate);
          } else {
            this.$refs.dateRangePicker.fp.setDate(this.defaultPickerDate);
          }
        }
      },
    },
  },

  methods: {
    onDateInput({event}) {
      this.$emit('update-shipping-date', {value: event, partType: this.partType});
    },
  },
};
</script>
